import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { colorThemeGenerator, ButtonPrimary, Type } from '@spotify-internal/encore-creator-web';
import { azure, white, spacer24 } from '@spotify-internal/encore-foundation';
import { EmailUnsubscribeHeader, Content } from './';
import { Footer } from '../LandingPage/Footer';
import { TextWithDesktopLineBreak } from '../Shared/TextWithDesktopLineBreak';
import { updateEmailSubscriptionPreference } from '../../lib/Api/subscription';
import { useMe } from '../../hooks/useMe';

export function Unsubscribe() {
  let { subscriptionToken } = useParams();
  let history = useHistory();
  let [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const me = useMe();

  const handleUnsubscribe = async () => {
    try {
      setIsButtonDisabled(true);

      await updateEmailSubscriptionPreference({
        isSubscribed: false,
        subscriptionToken,
        anonymous: me === null,
      });

      history.push(`/subscription/${subscriptionToken}/unsubscribe/success`);
    } catch {
      history.push(`/subscription/${subscriptionToken}/unsubscribe/error`);
    }
  };

  return (
    <>
      <EmailUnsubscribeHeader />
      <Content>
        <Type as="h1" variant={Type.heading2} weight={Type.bold}>
          Are you sure you want to unsubscribe?
        </Type>
        <Type as="p" variant={Type.body1} style={{ paddingBottom: spacer24 }}>
          We’ll no longer send you Spotify for Podcasters marketing messages.
          <TextWithDesktopLineBreak variant={Type.body1}>
            You may still receive important emails about your Spotify account.
          </TextWithDesktopLineBreak>
        </Type>
        <ButtonPrimary
          onClick={handleUnsubscribe}
          disabled={isButtonDisabled}
          theme={{
            ...colorThemeGenerator({
              primaryColor: azure,
              primaryColorText: white,
              primaryColorFocusText: white,
              primaryColorActiveText: white,
            }),
          }}
        >
          Yes, Unsubscribe
        </ButtonPrimary>
      </Content>
      <Footer />
    </>
  );
}
